<div class="space-y-5">
  <!-- Page Header -->
  <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h1 class="text-xl font-bold text-gray-900 dark:text-white">Registro de Auditoría</h1>
      <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Historial de acciones administrativas en la plataforma</p>
    </div>
    <span class="inline-flex items-center gap-1.5 rounded-full bg-gray-100 px-2.5 py-1 text-xs font-medium text-gray-600 dark:bg-gray-800 dark:text-gray-400">
      {{ totalCount }} registros
    </span>
  </div>

  <!-- Filter -->
  <div class="rounded-2xl border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-white/[0.03]">
    <div class="flex items-end gap-4">
      <div class="min-w-[180px]">
        <label class="mb-1.5 block text-xs font-medium text-gray-600 dark:text-gray-400">Tipo de acción</label>
        <select [(ngModel)]="actionFilter" (change)="onFilterChange()"
          class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
          aria-label="Filtrar por tipo de acción">
          <option value="all">Todas las acciones</option>
          <option value="impersonate">Impersonación</option>
          <option value="activate">Activación</option>
          <option value="deactivate">Desactivación</option>
          <option value="extend_membership">Extensión de membresía</option>
          <option value="set_membership_date">Cambio fecha membresía</option>
          <option value="reset_business">Reinicio</option>
          <option value="delete_business">Eliminación</option>
          <option value="support_reply">Respuesta de soporte</option>
          <option value="support_status">Estado de ticket</option>
        </select>
      </div>
    </div>
  </div>

  <!-- Entries -->
  @if (loading()) {
  <div class="space-y-3">
    @for (i of [1,2,3,4,5]; track i) {
    <div class="animate-pulse rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-white/[0.03]">
      <div class="flex items-center gap-4">
        <div class="h-10 w-10 rounded-lg bg-gray-200 dark:bg-gray-700"></div>
        <div class="flex-1">
          <div class="h-3 w-48 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div class="mt-2 h-3 w-32 rounded bg-gray-200 dark:bg-gray-700"></div>
        </div>
        <div class="h-3 w-24 rounded bg-gray-200 dark:bg-gray-700"></div>
      </div>
    </div>
    }
  </div>
  } @else if (entries().length === 0) {
  <div class="rounded-2xl border border-gray-200 bg-white p-12 text-center dark:border-gray-800 dark:bg-white/[0.03]">
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="mx-auto text-gray-300 dark:text-gray-600">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
    </svg>
    <p class="mt-4 text-sm text-gray-500 dark:text-gray-400">No hay registros de auditoría disponibles</p>
  </div>
  } @else {
  <div class="space-y-2">
    @for (entry of entries(); track entry.auditLogId) {
    <div class="rounded-xl border border-gray-200 bg-white px-4 py-3 transition hover:border-gray-300 dark:border-gray-800 dark:bg-white/[0.03] dark:hover:border-gray-700">
      <div class="flex items-center gap-4">
        <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg" [class]="getActionColor(entry.actionType)">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            @switch (getActionIcon(entry.actionType)) {
              @case ('user') { <path d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0"/> }
              @case ('play') { <polygon points="5 3 19 12 5 21 5 3"/> }
              @case ('pause') { <rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/> }
              @case ('calendar') { <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/> }
              @case ('refresh') { <polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/> }
              @case ('trash') { <polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/> }
              @default { <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/> }
            }
          </svg>
        </div>
        <div class="min-w-0 flex-1">
          <p class="text-sm font-medium text-gray-900 dark:text-white">
            <span class="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-700 dark:bg-gray-800 dark:text-gray-300">
              {{ getActionLabel(entry.actionType) }}
            </span>
            <span class="ml-2 text-gray-600 dark:text-gray-400">{{ entry.businessName }}</span>
          </p>
          @if (entry.details) {
          <p class="mt-0.5 truncate text-xs text-gray-500 dark:text-gray-400">{{ entry.details }}</p>
          }
        </div>
        <div class="shrink-0 text-right">
          <p class="text-xs text-gray-500 dark:text-gray-400">{{ formatDate(entry.createdAt) }}</p>
          <p class="mt-0.5 text-xs text-gray-400 dark:text-gray-500">{{ entry.performedByEmail }}</p>
        </div>
      </div>
    </div>
    }
  </div>

  <!-- Load More -->
  @if (entries().length < totalCount) {
  <div class="flex justify-center pt-4">
    <button (click)="onLoadMore()"
      class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
      Cargar más
    </button>
  </div>
  }
  }
</div>
